module.exports = __webpack_public_path__ + "static/media/step3_gif.e83b9a33.gif";